// src/js-coding/HeroSection.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import "../css-coding/HeroSection.css";

const HeroSection = () => {
  const navigate = useNavigate();

   const handleClick = () => {
    navigate("/services");
  };
  return (
    <section className="hero-container"> 
      <h1 className="hero-heading" style={{ color: "black" }}>
  Build Brands with <span style={{ color: "#FEAE01" }}>Purpose</span>
  <br />
  
</h1>

      <p className="hero-subtext">
        We Craft Content That Connects and Converts.
      </p>

      <button className="hero-button" onClick={handleClick}>
        Explore Our Services
      </button>

      <div className="hero-reviews">
        <span className="stars-h">★ ★ ★ ★ ★</span>
        <span className="review-text">Worked with 150+ Clients</span>
      </div>
    </section>
  );
};

export default HeroSection;
